/* @flow */

import React from 'react'

import UnattendedBranch from 'tve/components/unattended_branch'

const AppointmentGridFooter = ({ branch, customerType }) => {
  return <>{branch && branch.get('unattended') ? <UnattendedBranch customerType={customerType} /> : null}</>
}

export default AppointmentGridFooter
